import React, { Component } from "react";

import {
  TouchableOpacity,
  Content,
  View,
  Icon,
  Image,
  ListView,
  Modal,
  Navigator,
  RefreshControl,
  Text,
  StyleSheet
} from "react-1app";
import { Model } from "../infra";

import Menu from "./Menu.js";
import * as actions from "../redux/actions.js";
import AddGarantia from "./AddGarantia.js";

export default class Garantia extends Component {
  constructor(props) {
    super(props);
    this.state = { garantia: new Model("garantia"), loadgarantia: true };
    Navigator.cloneState(this);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });

    this.querygarantia();
  }

  querygarantia() {
    actions.garantiaBuscaTodos({}, data => {
      this.setState({ listgarantia: data, loadgarantia: false });
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps !== this.props) {
      this.querygarantia();

      //this.onUpdate(nextProps,nextState)
    }
    return true;
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  openModalAddgarantia() {
    this.props.screenProps.navigator.openModal({
      component: AddGarantia,
      props: {
        activity: this,
        garantia: new Model("garantia"),
        oldState: this.state
      }
    });
  }

  render() {
    return (
      <Content style={styles.content}>
        <Menu
          style={styles.fragment}
          ref={v => (this.menu = v)}
          screenProps={this.props.screenProps}
          navigation={this.props.navigation}
          activity={this}
          oldState={this.state}
        />
        <View style={styles.view}>
          <View style={styles.view1}>
            <Icon
              style={styles.icon11}
              fromFontFamily={"Material Icons"}
              name={"keyboard_arrow_right"}
            />
            <Text style={styles.text4}>{"Adicionar garantia"}</Text>
          </View>
          <ListView
            style={styles.garantia}
            refreshControl={
              <RefreshControl
                refreshing={this.state.loadgarantia}
                onRefresh={() => {
                  this.setState({ loadgarantia: true });
                }}
              />
            }
            dataSource={this.state.listgarantia}
            renderRow={(rowData, sectionID, rowID) => {
              return (
                <Cell
                  item={rowData}
                  screenProps={this.props.screenProps}
                  oldState={this.state}
                  activity={this}
                  navigation={this.state.navigation}
                  rowID={rowID}
                />
              );
            }}
            colorSeparator={"rgba(227,227,227,1)"}
            ref={v => (this.garantia = v)}
          />
          <TouchableOpacity
            style={styles.adajuda11}
            onPress={() => {
              this.openModalAddgarantia();
            }}
          >
            <Icon
              style={styles.icon111}
              fromFontFamily={"Material Design Icons"}
              name={"note-plus"}
            />
          </TouchableOpacity>
        </View>
      </Content>
    );
  }
}

class Cell extends Component {
  constructor(props) {
    super(props);
    this.state = { item: {}, garantia: new Model("garantia") };
    Navigator.cloneState(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps != this.props) Navigator.updateState(nextProps, nextState);
    if (nextProps !== this.props) {
      //this.onUpdate(nextProps,nextState)
    }
    return true;
  }

  openModalCell() {
    this.props.screenProps.navigator.openModal({
      component: AddGarantia,
      props: {
        activity: this.props.activity,
        oldState: this.state,
        garantia: this.props.item
      }
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <TouchableOpacity
        style={styles.cell}
        onPress={() => {
          this.openModalCell();
        }}
      >
        <TouchableOpacity
          style={styles.button1}
          onPress={() => {
            this.openModalCell();
          }}
        >
          <View style={styles.view4}>
            <View style={styles.view5}>
              <Image
                style={styles.image}
                resizeMode={"cover"}
                source={{ uri: this.props.item.imagem }}
              />
              <Text style={styles.text3}>{this.props.item.titulo}</Text>
              <Icon
                style={styles.icon5}
                fromFontFamily={"Material Icons"}
                name={"edit"}
              />
            </View>
            <View style={styles.view6}>
              <Text style={styles.text5}>{this.props.item.descricao}</Text>
              <Text style={styles.text2}>{this.props.item.corpo}</Text>
            </View>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    );
  }
}

var styles = StyleSheet.create({
  content: {
    backgroundColor: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row"
  },
  fragment: {
    alignSelf: "stretch"
  },
  view: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: "rgba(255,255,255,1)"
  },
  view1: {
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    padding: 10,
    backgroundColor: "rgba(238,238,238,1)"
  },
  icon11: {
    color: "rgba(181,181,181,1)",
    fontSize: 25
  },
  text4: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "auto",
    fontWeight: "normal",
    flex: 1,
    fontSize: 14
  },
  garantia: {
    alignSelf: "stretch",
    flex: 1
  },
  cell: {
    flexDirection: "column",
    alignSelf: "stretch",
    flex: 1,
    padding: 15,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    borderColor: "rgba(255,255,255,0)",
    paddingTop: 20,
    minHeight: 150
  },
  button1: {
    alignSelf: "stretch",
    justifyContent: "stretch",
    alignItems: "stretch",
    flexDirection: "column",
    flex: 1
  },
  view4: {
    alignSelf: "stretch",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    flexDirection: "column",
    paddingTop: 10,
    flex: 1
  },
  view5: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    flex: 1
  },
  image: {
    width: 50,
    height: 50,
    alignSelf: "auto",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    borderStyle: "solid",
    borderRadius: 25,
    borderColor: "rgba(251,174,23,1)",
    borderWidth: 2
  },
  text3: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontWeight: "normal",
    margin: 5,
    fontSize: 18,
    flexWrap: "wrap",
    flex: 1
  },
  icon5: {
    color: "rgba(17,41,55,1)",
    fontSize: 20
  },
  view6: {
    alignSelf: "stretch",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    flexWrap: "wrap",
    top: 20,
    paddingTop: 15,
    flex: 1
  },
  text5: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "auto",
    fontWeight: 100,
    margin: 5,
    fontSize: 14
  },
  text2: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "auto",
    fontWeight: 100,
    margin: 5,
    fontSize: 14,
    marginTop: 10,
    zIndex: 10
  },
  adajuda11: {
    alignSelf: "auto",
    justifyContent: "center",
    alignItems: "center",
    height: 50,
    flexDirection: "column",
    flexWrap: "nowrap",
    width: 50,
    backgroundColor: "rgba(255,135,0,1)",
    borderRadius: 25,
    position: "fixed",
    bottom: 20,
    right: 20,
    elevation: 5
  },
  icon111: {
    color: "rgba(255,255,255,1)",
    fontSize: 25
  }
});



// WEBPACK FOOTER //
// ./src/views/Garantia.js